import React, {useMemo} from 'react';
import {View, Dimensions} from 'react-native';
import EStyleSheet from "react-native-extended-stylesheet";

import AppText from "../../../components/AppText";
import AppButton from "../../../components/AppButton";
import {basicStyles} from "../../../styles/basic";
import {textStyles} from "../../../styles/text";
import ScreenOverlay from "../../../components/ScreenOverlay";
import ContentSection from "../../../components/ContentSection";
import MessageHtmlFrame from "../../../components/MessageHtmlFrame";
import {useDarkMode} from "../DarkModeContext";

function MessageHtmlModal({messageSubject, messageBodyHtml, handleClose, showImages = false, messageCC=null}) {
    const {isDarkMode, theme} = useDarkMode();
    const screenWidth = useMemo(() => {
        return Dimensions.get('window').width
    }, [])

    if (!messageBodyHtml) {
        return null;
    }

    return (
        <ScreenOverlay
            style={{position: 'fixed', left: screenWidth >= 630 ? 80 : 0, width: 'auto'}}
            onClick={() => {
                handleClose();
            }}>
            <ContentSection
                style={[styles.contentWrapper, isDarkMode && {backgroundColor: theme.background, borderColor: theme.border}]}
                onClick={e => {
                    e.stopPropagation();
                }}
            >
                <View style={styles.contentInner}>
                <View style={[
                    basicStyles.flexRow,
                    basicStyles.justifyContentSpaceBetween,
                    {
                        marginBottom: messageCC ? 8 : 20
                    }
                    ]}>
                    <View style={[basicStyles.flexScale]}>
                        {messageSubject && (
                            <AppText style={[
                                textStyles.pageTitle,
                                {
                                    marginBottom: messageCC ? 0 : 10,
                                },
                                isDarkMode && {color: theme.text},
                            ]}>
                                {messageSubject}
                            </AppText>
                        )}
                    </View>
                    <AppButton
                        label="Close"
                        action={handleClose}
                        theme="transBlue"
                    />
                </View>

                {messageCC && (
                    <View>
                        {messageCC && (
                            <AppText style={[textStyles.pageSubTitle, {marginBottom: 10}, isDarkMode && {color: theme.textSecondary}]}>
                                CC: {messageCC}
                            </AppText>
                        )}
                    </View>
                )}

                <View style={[styles.htmlFrameContainer, isDarkMode && {borderColor: theme.border}]}>
                    <MessageHtmlFrame html={messageBodyHtml} showImages={showImages} expandToFullHeight={true} isDarkMode={isDarkMode} />
                </View>
                </View>
            </ContentSection>
        </ScreenOverlay>
    );
}

export default MessageHtmlModal;

const styles = EStyleSheet.create({
    contentWrapper: {
        padding: 32,
        width: 900,
        maxWidth: '90%',
        maxHeight: '90%',
    },
    contentInner: {
        flex: 1,
        minHeight: 0,
    },
    htmlFrameContainer: {
        width: '100%',
        flex: 1,
        minHeight: 400,
        borderWidth: 1,
        borderColor: '#E2E9F4',
        borderRadius: 8,
        overflow: 'hidden',
    }
});

